import request from '@/utils/request'

export const getUserInfo = () =>
  request({
    url: '/menuUser/getUserMenus',
    method: 'get'
  })

export const login = (data: any) =>
  request({
    url: '/pz/token/login',
    method: 'post',
    data
  })

export const logout = () =>
  request({
    url: '/pz/token/loginOut',
    method: 'get'
  })

export const register = (data: any) =>
  request({
    url: '/users/register',
    method: 'post',
    data
  })
